__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/2b382a1/_next/";